module.exports = __webpack_public_path__ + "img/icon_4_48.6e7b6781.png";